export default function search(
	state = { runners: [], updatedRunners: null, events: [], potentialFriends : []},
	action
) {
	var copy = Object.assign({}, state);
	if (action.type === "searchRunners") {
		copy.runners = action.runners;
		copy.updatedRunners = action.updatedRunners;
    return copy;

	} else if (action.type === "initRunners") {
		copy.runners = action.runners;
		return copy
	}
	else if (action.type === "reinitRunners") {
		copy.updatedRunners = null;
	 return copy
	}
	else if (action.type === "POTENTIAL_FRIENDS") {
		copy.potentialFriends = action.potentialFriends;
	 return copy
	}

	else if (action.type === "DISPATCH_EVENTS") {
	copy.events = action.events;
	return copy
	}
		else {
		return state
	}
}
